export enum EventOfInterestType {
	AllUpdates = 0, // Used on the My Updates screen
	NewCompany = 1,
	CompanyUpdate = 2, // Includes shared and profile updates
	InTheNews = 3,
}
